import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { formatUserRoleType } from "@utils/data-display";
import { Text } from "@flat-ui";
import { Props as FaroSelectProps } from "@components/common/faro-select/faro-select-utils";
import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";

interface Props {
  /** Member role to display */
  role:
    | FaroCoreApiTypes.CompanyRole
    | FaroCoreApiTypes.ProjectRole
    | FaroCoreApiTypes.GroupRole;

  /** Props to pass to the SelectCompanyRole component */
  variant: FaroSelectProps<string>["variant"];
}

/**
 * Read-only display of a member's role.
 * Used across different role column components (company, project, group).
 *
 * @param role - The role to display
 * @returns Formatted role text
 */
export function MemberRoleReadOnly({ role, variant }: Props): JSX.Element {
  const formattedRole = formatUserRoleType(role);

  if (variant !== "standard") {
    return <Text variant="bodyS">{formattedRole}</Text>;
  }

  return (
    <FaroTextField
      label="Workspace role"
      initialValue={formattedRole}
      faroVariant="main"
      fontSize="18px"
    />
  );
}
